AuthRoute = require 'mixins/authenticated-route'

App.ModifierGroupsRoute = Em.Route.extend AuthRoute,
  queryParams:
    actuality:
      refreshModel: true

  beforeModelAuth: (transition) ->
    Em.RSVP.hash(
      organization: @get('session').get('currentOrganization')
      restaurants:  @store.find('restaurant', {})
    ).then (props) =>
      @controllerFor('modifier-groups').setProperties(props)

  model: (params) ->
    @store.filter('modifierGroup', params, -> true)

  actions:
    goBackToModifierGroupList: ->
      @transitionTo 'modifier-groups'
      false
